<script setup>
/* eslint semi: 1 */
import { computed, inject } from 'vue';
import { FwbButton, FwbInput } from 'flowbite-vue';

const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['update:modelValue', 'invite-user-click']);

const searchKey = computed({
  get: () => props.modelValue,
  set: (newValue) => emit('update:modelValue', newValue),
});

const $currentUser = inject('$currentUser');
const $signedInUserInfo = inject('$signedInUserInfo');

const createNewUserEnabled = computed(() => {
  return $currentUser.hasGroupExtended() && !$signedInUserInfo.value?.activePlan?.suspended;
});
</script>

<template>
  <div class="bg-white flex flex-col gap-4 p-4! h-auto!">
    <div class="flex flex-row items-center justify-between">
      <FwbInput
        v-model.trim="searchKey"
        :placeholder="$t('label.search')"
        class="w-[250px]"
        input-class="px-4"
        size="sm"
      />

      <FwbButton
        v-if="createNewUserEnabled"
        color="default"
        size="sm"
        class="border-none py-2 font-medium"
        @click="$emit('invite-user-click')"
      >
        <template #prefix>
          <BaseIconSvg
            name="flowbite:plus-outline"
            class="w-4! h-4!"
          />
        </template>
        {{ $t('buttons.addNewUser') }}
      </FwbButton>
    </div>
  </div>
</template>
